import {useEffect, useRef, useState} from 'react';

export function useFirstInViewport(element, options) {
    const [entered, setEntered] = useState(false);
    const observer = useRef(
        new IntersectionObserver(
            ([entry]) => {
                setEntered(entry.isIntersecting);
            },
            options
        )
    );

    useEffect(() => {
        const ob = observer.current;
        if (entered) {
            ob.disconnect();
            return;
        }
        if (element?.current && !entered) ob.observe(element.current);
        return () => {
            ob.disconnect();
        };
    }, [element, entered]);

    return entered;
}
